import {
  ASN,
  Container,
  FreightShipment,
  Generic,
  Pallet,
  ParcelShipment,
  Place,
  Transload,
} from 'src/api/models'

import { Action, ApplyScan } from './interface'
import { Handler, HandlerInput } from './base'

export type MoveContainerHandlerCallback = () => void

interface MoveContainerHandlerInput extends HandlerInput {
  source: Generic
}

export class MoveContainerHandler extends Handler {
  source: Generic
  items: Generic[]
  callbacks: MoveContainerHandlerCallback[]

  constructor(props: MoveContainerHandlerInput) {
    super(props)
    this.source = props.source
    this.items = []
    this.callbacks = []
  }

  apply = ({ scanned }: ApplyScan): [Action, any | undefined] => {
    switch (scanned.object.type) {
      case Transload.type:
      case Container.type:
      case Pallet.type: {
        const index = this.items.map((g) => g.object.guid).indexOf(scanned.object.guid)
        if (index < 0) {
          this.items.push(scanned)
        }
        break
      }
      case Place.type:
      case ASN.type:
      case FreightShipment.type:
      case ParcelShipment.type: {
        const inventory = this.items.map((item) => {
          return {
            item: item.object.guid,
            num: 0,
          }
        })
        return [
          Action.Move,
          { source: this.source.object.guid, items: inventory, destination: scanned.object.guid },
        ]
      }
    }
    this.notify({})
    return [Action.Invalid, undefined]
  }

  getContext = () => {
    return { activity: 'moving', source: this.source.object.guid }
  }
}
